import {Component, Input, OnInit} from '@angular/core';
import {CityDTO} from '../../../../shared/dto/city.model';
import {DistrictDTO} from '../../../../shared/dto/district.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DistrictService} from '../../../../shared/service/district.service';
import {CityService} from '../../../../shared/service/city.service';
import {CityComponent} from '../city.component';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import swal from "sweetalert2";
import {CityPopupComponent} from '../city-popup/city-popup.component';

@Component({
  selector: 'app-city-search-table',
  templateUrl: './city-search-table.component.html',
  styleUrls: ['./city-search-table.component.scss']
})
export class CitySearchTableComponent implements OnInit {
  @Input() items: CityDTO[];
  @Input() index: number;
  @Input() page: number=1;
  @Input() itemsPerPage: number=5;
  private districtDTOS: DistrictDTO [] = [];
  private cityDTOS: CityDTO[] = [];

  constructor( public modalService: NgbModal,
               private districtService: DistrictService,
               private cityService: CityService,
               private cityMgt: CityComponent,) { }

  ngOnInit() {
    this.loadCities();
    this.loadDistricts();
  }

  loadDistricts() {
    this.districtService.getAllDistricts().subscribe(
      (data: DistrictDTO []) => {
        this.districtDTOS = data;
      }
    );
  }

  loadCities() {
    this.cityService.getAllCityDetails().subscribe(
      (data: CityDTO[]) => {
        this.cityDTOS = data;
      }
    );
  }

  onClickUpdate(Item){
    const modalRef = this.modalService.open(CityPopupComponent, {
      windowClass: "xlModal"
    });
    modalRef.componentInstance.name = "Update City Details";
    modalRef.componentInstance.code =  Item.cityCode;
    modalRef.componentInstance.description = Item.description;
    modalRef.componentInstance.selectedState = Item.status;
    modalRef.componentInstance.district = Item.district;
    modalRef.componentInstance.cityMgtCopy_ = Item;
    modalRef.componentInstance.selectedMode = ActionMode.UPDATE;
    modalRef.result.then(
      (data: string) => {
        if (data == "Saved") {
          this.cityMgt.onLoadGetData();
        }
      },
      () => { }
    );
  }

  onDelete(Item) {
    swal.fire({
      title: "Are you sure, you want to delete?",
      text: "",
      showCancelButton: true,

      confirmButtonText: "Yes"
    }).then(
      (result) => {
        if(result.value) {
          this.cityService.deleteCityDetails(Item.cityCode).subscribe(
            (res: boolean) => {
              if (res === true) {
                swal.fire("Success", "Details Deleted successfully", "success");
                this.items.splice(Item, 1);
                this.loadDistricts();
              } else if (res === false) {
                swal.fire("Sorry!", "Details can't be deleted...!", "error");
              }
            },
            (error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
              this.loadDistricts();
            }
          );
        }
      }, reason => {
      }
    );
  }

  onClickView(Item){
    const modalRef = this.modalService.open(CityPopupComponent, {
      windowClass: "xlModal"
    });
    modalRef.componentInstance.name = "View City Details";
    modalRef.componentInstance.code =  Item.cityCode;
    modalRef.componentInstance.description = Item.description;
    modalRef.componentInstance.selectedState = Item.status;
    modalRef.componentInstance.district = Item.district;
    modalRef.componentInstance.districtMgtCopy_ = Item;
    modalRef.componentInstance.selectedMode = ActionMode.VIEW;
  }

}
